<template>
  <div>
    <div class="product_sh_mask"></div>
    <div class="product_sh">
      <slot></slot>
      <a href="javascript:void(0);" class="close" title="close" @click="close">close</a>
    </div>
  </div>
</template>

<script> 
export default {
  name: 'slidePopup',
  methods : {
    open () {
      var $el = $(this.$el);
      $el.find('.product_sh').addClass('on');
      $el.find('.product_sh_mask').fadeIn();            
    },
    close () {
      var $el = $(this.$el);
      $el.find('.product_sh').removeClass('on');
      $el.find('.product_sh_mask').fadeOut(); 
    }
  }
}
 </script>



// WEBPACK FOOTER //
// src/components/SlidePopup.vue